import { DiscountType } from '~/models';
export const billClientLoader = 'billClientLoader';
export var BillMode = /*#__PURE__*/ function(BillMode) {
    /** Bill now, with issueDate that's now or in the past. */ BillMode["Now"] = "now";
    /** Add to upcoming invoice. */ BillMode["Upcoming"] = "upcoming";
    /** Bill on future date. */ BillMode["FutureDate"] = "futureDate";
    return BillMode;
}({});
export var BillingType = /*#__PURE__*/ function(BillingType) {
    BillingType["Charge"] = "charge";
    BillingType["Service"] = "service";
    return BillingType;
}({});
export var ServiceFormDataType = /*#__PURE__*/ function(ServiceFormDataType) {
    ServiceFormDataType["Default"] = "default";
    ServiceFormDataType["Stages"] = "stages";
    return ServiceFormDataType;
}({});
export const InitialDiscount = {
    type: DiscountType.Percent,
    amount: ''
};
